import React from 'react'
import { Link } from 'gatsby'

import facebook from '../img/social/facebook.svg'
import instagram from '../img/social/instagram.svg'
import twitter from '../img/social/twitter.svg' 

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer has-background-black has-text-white-ter">
          <div className="content has-text-centered">
            <h2 style={{color:'#ff5a00',fontSize:'3rem'}}>City Stage LLC</h2>
          </div>
          <div className="content has-text-centered has-background-black has-text-white-ter">
            <div className="container has-background-black has-text-white-ter">
              <div className="columns">
                <div className="column is-4">
                  <section className="menu">
                    <ul className="menu-list contact">
                         {/* contact info - phone email address*/}
                         <li style={{margin:"1rem 0",fontWeight:"bold"}}>
                         <p>Phone : 603-785-0837</p>
                         </li>
                         <li style={{margin:"1rem 0",fontWeight:"bold"}}>
                         <p>Email : citystagela@gmail.com</p>
                         </li>
                         <li style={{margin:"1rem 0",fontWeight:"bold"}}>
                            <address> <p>Address : </p> <p> A99 Adam Street</p>
                            <p>Texas, TX 555072</p></address>
                         </li>
                  </ul>
                </section>
              </div>
              <div className="column is-4">
                <section>                  
                  <ul className="menu-list">
                  <li>
                      <Link to="/" className="navbar-item">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/about">
                        About
                      </Link>
                    </li>           
                    <li>
                      <Link className="navbar-item" to="/blog">
                        Latest Events
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column is-4 social">
                <a title="facebook" href="https://facebook.com">
                  <img
                    src={facebook}
                    alt="Facebook"
                    style={{ width: '1em', height: '1em' }}
                  />
                </a>
                <a title="twitter" href="https://twitter.com">
                  <img
                    className="fas fa-lg"
                    src={twitter}
                    alt="Twitter"
                    style={{ width: '1em', height: '1em' }}
                  />
                </a>
                <a title="instagram" href="https://instagram.com/citystagela">
                  <img
                    src={instagram}
                    alt="Instagram"
                    style={{ width: '1em', height: '1em' }}
                  />
                </a> 
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
